import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// Your web app's Firebase configuration  *in production
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCTjkwPpPJ4ezLH2Al4W1v4lR7lhiGTGhs",
  authDomain: "oranjemund-town-council-b69df.firebaseapp.com",
  projectId: "oranjemund-town-council-b69df",
  storageBucket: "oranjemund-town-council-b69df.firebasestorage.app",
  messagingSenderId: "797536480394",
  appId: "1:797536480394:web:44738b7ba58704c4c25173",
  measurementId: "G-W3LEE5PMYG",

  // apiKey: "AIzaSyDasgXX3u3cLujb7rwGlJpqgXV2wwfmKS8",
  // authDomain: "nkurenkuru-town-council.firebaseapp.com",
  // projectId: "nkurenkuru-town-council",
  // storageBucket: "nkurenkuru-town-council.appspot.com",
  // messagingSenderId: "651659197779",
  // appId: "1:651659197779:web:122730299f6c30bbacf5a6",
  // measurementId: "G-N3BJ50MDSN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const appAuthWorker = initializeApp(firebaseConfig, "authWorker");

export const auth = getAuth(app);
export const authWorker = getAuth(appAuthWorker);

export const analytics = getAnalytics(app);
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

export const storage = getStorage(app);
export const functions = getFunctions(app);
